/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const availabilityOptions = [
    'available',
    'partially available',
    'not reservable',
    'lottery',
    'CAMPING_LOTTERY',
    'unavailable',
    'new',
    'enter dates',
    'enter date',
    'view availability',
] as const;

export type Availability = (typeof availabilityOptions)[number];

export function validateAvailability(value: unknown) {
    if (
        typeof value === 'string' &&
        availabilityOptions.includes(value as Availability)
    ) {
        return value as Availability;
    }

    return undefined;
}

export type CarouselCardItem = {
    availability?: Availability;
    availability_counts?: {
        available?: number;
    };
    available_dates?: Array<{ start_date: string; end_date: string }>;
    average_rating?: number;
    campsite_equipment_name?: string[];
    campsite_max_vehicle_length?: number;
    campsite_reserve_type?: string[];
    campsite_type_of_use?: string[];
    campsites_count?: string;
    city?: string;
    country_code?: string;
    distance?: string;
    entity_id?: string;
    entity_type?: string;
    id?: string;
    latitude?: string;
    longitude?: string;
    name?: string;
    number_of_ratings?: number;
    org_id?: string;
    org_name?: string;
    parent_id?: string;
    parent_name?: string;
    parent_type?: string;
    preview_image_url?: string;
    price_range?: {
        amount_max?: number;
        amount_min?: number;
        per_unit?: string;
        additional_desc?: string;
    };
    reservable?: boolean;
    state_code?: string;
    time_zone?: string;
    type?: string;
};
